import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {SUMMARY_REPORT_TYPE} from 'pages/Analysis/EEGSummary/constants'
import {RootState, ThunkExtraArguments} from 'store'

export interface OpenDialogPayload {
  title?: string
  message: string
  addItem?: string
}

interface ConfirmState {
  isOpened: boolean
  title?: string
  message?: string
  additionalItem?: string
  isConfirmed: boolean
  isDeclined: boolean
  keyAddItem?: number
}

const initialState: ConfirmState = {
  isOpened: false,
  isConfirmed: false,
  isDeclined: false,
  additionalItem: '',
  keyAddItem: 0,
}

const slice = createSlice({
  name: 'noticeConfirmV2',
  initialState,
  reducers: {
    open(state, action: PayloadAction<OpenDialogPayload>) {
      state.isOpened = true
      state.isConfirmed = false
      state.isDeclined = false

      state.additionalItem = action.payload.addItem
      state.title = action.payload.title
      state.message = action.payload.message
    },
    confirm(state) {
      state.isOpened = false
      state.isConfirmed = true
      state.isDeclined = false

      state.additionalItem = ''
      state.title = undefined
      state.message = undefined
    },
    reject(state) {
      state.isOpened = false
      state.isConfirmed = false
      state.isDeclined = true

      state.additionalItem = ''
      state.title = undefined
      state.message = undefined
    },
    select(state, action: PayloadAction<number>) {
      state.keyAddItem = action.payload
    },
  },
})

export const {open, confirm, reject, select} = slice.actions

export default slice.reducer

export const selectNoticeConfirm = (state: RootState) => ({
  isOpened: state.noticeConfirmV2.isOpened,
  isConfirmed: state.noticeConfirmV2.isConfirmed,
  isDeclined: state.noticeConfirmV2.isDeclined,
  title: state.noticeConfirmV2.title,
  message: state.noticeConfirmV2.message,
  additionalItem: state.noticeConfirmV2.additionalItem,
  keyAddItem: state.noticeConfirmV2.keyAddItem,
})

export const confirmNoticeAction = createAsyncThunk<
  boolean,
  OpenDialogPayload,
  {extra: ThunkExtraArguments}
>('modal/noticeConfirmV2', async (payload, {dispatch, extra}) => {
  const {store} = extra
  dispatch(open(payload))
  return new Promise<any>((resolve) => {
    const unsubscribe = store.subscribe(() => {
      const state: RootState = store.getState()
      if (state.noticeConfirmV2.isConfirmed) {
        unsubscribe()
        if (payload.addItem === SUMMARY_REPORT_TYPE) {
          resolve({isConfirmed: true, key: state.noticeConfirmV2.keyAddItem})
        } else {
          resolve(true)
        }
      }
      if (state.noticeConfirmV2.isDeclined) {
        unsubscribe()
        resolve(false)
      }
    })
  })
})
